import {useEffect, useState, useRef} from 'react';
import {fmexHtmlFormatter} from '_app/utils';
import './html-media-content.less';

export const HtmlMediaContent = ({content}) => {
	const [model, setModel] = useState(fmexHtmlFormatter.applyHtmlFormatting(content));
	const iFrameRef = useRef();
	const [height, setHeight] = useState('0px');
	const onLoad = () => {
	  setHeight(`${iFrameRef.current.contentWindow.document.body.scrollHeight}px`);
	};
	const onWindowResize = () => {
		if (window.innerWidth < 750) {
			const formattedHtml = fmexHtmlFormatter.formatSingleColumnHtml(model);

			setModel(formattedHtml);
		}
	};

	useEffect(() => {
		onWindowResize();
		window.addEventListener('resize', onWindowResize);
	},[]);

	return (
		<iframe
			srcDoc={`<div class="html-media-content">${model}</div>`}
			ref={iFrameRef}
			onLoad={onLoad}
			sandbox="allow-same-origin"
			height={height}
			scrolling="no"
			frameBorder="0"
		/>
	);
};